// extracted by mini-css-extract-plugin
export var container = "_3z-0";
export var error = "_3z-9";
export var label = "_3z-5";
export var light = "_3z-6";
export var md = "_3z-3";
export var sm = "_3z-2";
export var thin = "_3z-8";
export var thinBold = "_3z-7";
export var vertical = "_3z-4";
export var xs = "_3z-1";